import * as React from 'react';

// Utils
import { take } from '@src/shared/src/util/general';
import { useTranslation } from 'react-i18next';

// Constants
// Actions, Models & Interfaces
// Components
import HotelFacilitiesAll from './HotelFacilitiesAll';

// Styles
import '../styles/HotelFacilities.scss';

type Props = {
  facilities: string[];
};

const HotelFacilities: React.FC<Props> = ({ facilities }) => {
  const { t } = useTranslation();

  const getFacilitiesMarkup = (facilities: string[]) => {
    return (
      <ul>
        {take(12, facilities).map((currFacility: string, idx: number) => (
          <li key={`${currFacility}-${idx}`}>
            <i className="material-symbols" aria-hidden="true">
              check_circle
            </i>
            {currFacility}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="tcp-hotel-facilities">
      <div className="tcp-hotel-facilities-inner">{getFacilitiesMarkup(facilities)}</div>
      <HotelFacilitiesAll facilities={facilities} label={t('hotelFacilities.showMore')} overlayTitle={t('hotel.details.facilities')} />
    </div>
  );
};

export default HotelFacilities;
